import { render } from "./NcrmLeadContextActions.vue?vue&type=template&id=87b589de"
import script from "./NcrmLeadContextActions.vue?vue&type=script&lang=js"
export * from "./NcrmLeadContextActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__